module.exports = __webpack_public_path__ + "img/img_owned_patent08.56a42900.jpg";